import { Box, Button, TextField, InputAdornment, SvgIcon, Grid } from '@mui/material';
import { SearchIcon } from "../../Icons"
import Select from "react-select";
import CUModal from '../modals/CUModal';
import { useState } from 'react';
import CUClassroomActivity from "../CreateUpdateComponents/ClassroomActivity";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";



const ClassroomActivityListToolbar = ({
    readOnly,
    period,
    loadData,
    daysOptions,
    classroomsOptions,
    dayFilter,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    availableFilter,
    setAvailableFilter,
    updateDayFilter,
    updateClassroomFilter,
    updateSearch,
    ...props }) => {

    const [openCUModal, setOpenCUModal] = useState(false);
    const handleClose = () => { setOpenCUModal(false); loadData(); }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={moment.locale("fr")}>

            <CUModal open={openCUModal} handleClose={handleClose} period={period} component={CUClassroomActivity} />
            <Box {...props}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!readOnly && <Button color="primary" variant="contained" onClick={() => setOpenCUModal(true)}>Ajouter</Button>}
                </Box>
                <Box pb={4}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} lg={6}>
                            <TextField
                                size="small"
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                                        </InputAdornment>
                                    )
                                }}
                                placeholder="Rechercher un cours"
                                variant="outlined"
                                onChange={updateSearch}
                            />
                        </Grid>
                        <Grid item xs={false} md={false} lg={6} />
                        <Grid item xs={12} md={12} lg={3}>
                            <TimePicker
                                fullWidth
                                renderInput={(props) => <TextField {...props} size="small" fullWidth />}
                                invalidDateMessage="Format d'heure invalide"
                                label="Démarre après"
                                inputVariant="outlined"
                                minutesStep={5}
                                value={startTime}
                                size="small"
                                ampm={false}
                                onChange={setStartTime}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <TimePicker
                                fullWidth
                                renderInput={(props) => <TextField {...props} size="small" fullWidth />}
                                invalidDateMessage="Format d'heure invalide"
                                minutesStep={5}
                                label="Termine avant"
                                inputVariant="outlined"
                                value={endTime}
                                size="small"
                                ampm={false}
                                onChange={setEndTime}
                            />
                        </Grid>
                        <Grid item xs={6} />
                        <Grid item xs={12} md={12} lg={3}>
                            <Select
                                minMenuHeight={1000}
                                placeholder="Jours..."
                                isClearable={true}
                                isSearchable={true}
                                defaultValue={[]}
                                name="day"
                                isMulti
                                onChange={updateDayFilter}
                                options={daysOptions}
                            />
                        </Grid>
                        {classroomsOptions.length === 0 ? <Grid item xs={2} /> : (
                            <Grid item xs={12} md={12} lg={3}>
                                <Select
                                    minMenuHeight={1000}
                                    placeholder="Classes..."
                                    noOptionsMessage={() => "Pas d'autres classes disponibles"}
                                    isClearable={true}
                                    isSearchable={true}
                                    defaultValue={[]}
                                    name="day"
                                    isMulti
                                    onChange={updateClassroomFilter}
                                    options={classroomsOptions}
                                />
                            </Grid>)}
                    </Grid>
                </Box>
            </Box >
        </LocalizationProvider>
    )
};

export default ClassroomActivityListToolbar;